// The sales chips' variants, stated once (spec 09 §4.1, §4.7). They lived in
// the customer and order book screens, and E2-1's side peeks paint the same
// chips from a component the books themselves import, so the rules moved here
// and the two screens re-export them under their old names.

import type { ChipVariant } from "../../../../components/status-chip";

/** §2.1's tier vocabulary → the §3.5 chip variant, stated once: distributor
 * is ACCENT (the governed tier — the eligible list exists for it), the other
 * two are neutral facts. Green/red stay reserved for verdicts. */
export function tierChipVariant(tier: string): ChipVariant {
  return tier === "distributor" ? "accent" : "neutral";
}

/** §3.6's order states → a chip. A cancelled order is neutral, not red:
 * painting it red puts every deliberate cancellation on the same footing as a
 * broken one. `pending_approval` is the only amber: it is the one state where
 * somebody is waiting on a person. */
export function orderStatusVariant(status: string): ChipVariant {
  switch (status) {
    case "pending_approval":
      return "warn";
    case "delivered":
    case "closed":
      return "ok";
    case "confirmed":
    case "in_production":
    case "ready":
    case "shipped":
      return "accent";
    default:
      return "neutral";
  }
}

/** §2.16's credit column → a chip. Both `blocked_*` states are RED because
 * both stop fulfilment (shipment creation answers 409 while either holds);
 * `override_approved` is amber, not green, because it records that somebody
 * decided to ship over a limit — a fact the next reader should see. */
export function creditChipVariant(status: string): ChipVariant {
  switch (status) {
    case "blocked_credit":
    case "blocked_prepay":
      return "bad";
    case "override_approved":
      return "warn";
    default:
      return "ok";
  }
}
